<ng-container *transloco="let t;">
<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" (click)="activeModal.close('Cross click')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
      </button>
</div>
<form [formGroup]="add_new_form" (ngSubmit)="addNew()">
    <div formGroupName="template">
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="form-group">
                <label>{{label}} </label>
                <div class="form-group">
                    <input formControlName="name" type="text" placeholder="{{label}}" class="form-control" [ngClass]="{ 'is-invalid error': submitted && add_new_form.controls?.template?.controls.name.errors }" />
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button [disabled]="loader" type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Cross click')" rippleEffect>
          {{t("Cancel button text (cancel button) - cancel")}}
      </button>
            <button [disabled]="loader" type="submit" class="btn btn-success" rippleEffect>
          <span *ngIf="loader" class="spinner-border spinner-border-sm me-1"></span> {{t("Add button title (add button) - Add")}}
      </button>
        </div>
    </div>
</form>
</ng-container>